import { useNavigate } from 'react-router-dom';
import { X, UserPlus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';

export default function GuestPromptDrawer() {
  const navigate = useNavigate();
  const { showGuestPrompt, setShowGuestPrompt, exitGuestMode } = useAuth();

  // Lock body scroll when drawer is open
  useBodyScrollLock(showGuestPrompt);

  if (!showGuestPrompt) return null;

  const handleSignUp = () => {
    setShowGuestPrompt(false);
    exitGuestMode();
    navigate('/signup');
  };

  const handleSignIn = () => {
    setShowGuestPrompt(false);
    exitGuestMode();
    navigate('/signin');
  };

  const handleClose = () => {
    setShowGuestPrompt(false);
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-50 animate-fade-in"
        onClick={handleClose}
      />

      {/* Drawer */}
      <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
        <div className="bg-white rounded-t-3xl p-6 pb-[calc(1.5rem+env(safe-area-inset-bottom))]">
          {/* Handle */}
          <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4" />

          {/* Close button */}
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full"
          >
            <X size={20} />
          </button>

          {/* Content */}
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <UserPlus className="text-indigo-600" size={28} />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Create your account to start enjoying group rewards
            </h2>
            <p className="text-gray-600 text-sm">
              Join groups, unlock exclusive deals, and earn rewards with your community.
            </p>
          </div>

          {/* Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleSignUp}
              className="w-full py-4 bg-indigo-600 text-white font-bold rounded-2xl text-lg hover:bg-indigo-700 transition-colors"
            >
              Get Started
            </button>
            <button
              onClick={handleSignIn}
              className="w-full py-4 bg-indigo-50 text-indigo-600 font-bold rounded-2xl text-lg hover:bg-indigo-100 transition-colors"
            >
              Sign In
            </button>
            <button
              onClick={handleClose}
              className="w-full py-3 text-gray-500 font-medium text-base hover:text-gray-700 transition-colors"
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
